import { Questionnaire } from "@shared/types";
import { config } from "../config/config";

export const sendForm = async (formState: Partial<Questionnaire>) => {
  return fetch(`${config.BACKEND_URL}/send`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formState),
  });
};

export const sendNewLead = async (data: { email: string }) => {
  return fetch(`${config.LEAD_BACKEND_URL}/customer/interest`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};
